import { render, staticRenderFns } from "./modal-offer-xmas-1.vue?vue&type=template&id=be967558"
import script from "./modal-offer-xmas-1.vue?vue&type=script&lang=js"
export * from "./modal-offer-xmas-1.vue?vue&type=script&lang=js"
import style0 from "./modal-offer-xmas-1.vue?vue&type=style&index=0&id=be967558&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports